import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { User } from "model";

import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from 'components/shared';
import { SVGAsset } from 'res';
import AuthorizedDevicesTable from './components/AuthorizedDevicesTable';

import "./styles.css";
import "./mobile.css";


export default function AuthorizedDevicesPage(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const data = { ...getDefaultPageData(), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui
    });

    return (
        <PageContainer className="authorized-devices-page" state={ { data, ui } } controller={ controller }>
            <AuthorizedDevicesContent />
        </PageContainer>
    );
}

export const getDefaultPageData = () => ({});
export const getDefaultPageUI = () => ({});

function AuthorizedDevicesContent(props) {
    const { state: model } = useBCMSContext();
    const user = User.init(model.user);

    return (
        <PageContentView>
            <CenterContentContainer>
                <ContentHeaderView text="Authorized Devices" />
                <div className="flex-container flex-horizontal align-top info-container content-container">
                    <div className="set-width">
                        <SVGAsset id="InfoIcon" />
                    </div>
                    <div className="flex-width">
                        <p>To enroll a new device, you must use the mobile app.</p>
                    </div>
                </div>
                <div className="content-container user-info-container">
                    <p>
                        <span>The following devices are enrolled for biometric authentication for</span> <span className="user-text">{ user.id }.</span>
                    </p>
                </div>
                <AuthorizedDevicesTable />
            </CenterContentContainer>
        </PageContentView>
    );
}